import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';

export const DocumentPreviewDialog = ({ doc, url, onClose }) => {
    const isImage = /^image\//.test(doc?.content_type || '');
    return (
        <Dialog open={!!doc} onOpenChange={(o) => { if (!o) onClose(); }}>
            <DialogContent className="max-w-4xl w-[95vw] p-4" data-testid="document-preview-dialog">
                <DialogHeader>
                    <DialogTitle className="text-base truncate pr-8" data-testid="document-preview-title">{doc?.filename}</DialogTitle>
                    <DialogDescription className="sr-only">Anteprima documento</DialogDescription>
                </DialogHeader>
                <div className="h-[70vh] bg-muted/40 rounded-sm overflow-auto flex items-center justify-center">
                    {!url ? (
                        <p className="text-sm text-muted-foreground">Caricamento…</p>
                    ) : isImage ? (
                        <img src={url} alt={doc?.filename} className="max-w-full max-h-full object-contain" data-testid="document-preview-image" />
                    ) : (
                        <iframe src={url} title={doc?.filename} className="w-full h-full border-0 bg-white" data-testid="document-preview-pdf" />
                    )}
                </div>
                <div className="flex justify-end">
                    <Button variant="outline" disabled={!url} onClick={() => window.open(url, '_blank')} data-testid="document-preview-open-btn">
                        <ExternalLink size={16} className="mr-2" /> Apri a schermo intero / Scarica
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};
